import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["disabled", "children", "defaultValue", "error", "bgColor"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/core/components/Forms/FormField.js",
  _this = this;
import React, { useCallback, useMemo, useState } from 'react';
import styled, { css } from 'styled-components';
import { withTheme, useTheme } from '../../ThemeProvider';
import { responsiveStyles } from '../../../core/utils/responsiveStyles';
export var FormFieldContext = /*#__PURE__*/React.createContext(null); // TODO Sudhir: Add documentation specific to this component.

var FormField = function FormField(_ref) {
  var disabled = _ref.disabled,
    children = _ref.children,
    defaultValue = _ref.defaultValue,
    error = _ref.error,
    bgColor = _ref.bgColor,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focus = _useState2[0],
    setFocus = _useState2[1];
  var _useState3 = useState(!!defaultValue),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var onFocus = useCallback(function () {
    return !disabled && setFocus(true);
  }, [disabled]);
  var onBlur = useCallback(function () {
    return setFocus(false);
  }, []);
  var backgroundColor = useMemo(function () {
    return bgColor === 'haze' ? theme.cl_ter_l6 : theme.cl_white;
  }, [bgColor]);
  var handleMouseDown = function handleMouseDown(e) {
    /**
     * If the field is already in focus, clicking on it again
     * causes the input field to lose focus.
     * To prevent this the event should be stopped here from being
     * propagated to the input/select children element(s).
     */
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (!focus) {
      onFocus();
    } else {
      e.preventDefault();
    }
  };
  var formFieldApi = useMemo(function () {
    return {
      onFocus: onFocus,
      onBlur: onBlur,
      setValue: setValue,
      hasFocus: focus,
      hasValue: !!value
    };
  }, [focus, value]);
  return /*#__PURE__*/React.createElement(FormFieldContainer, _extends({
    onMouseDown: handleMouseDown
  }, rest, {
    disabled: !!disabled,
    bgColor: backgroundColor,
    error: error,
    hasFocus: focus,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(InputContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(FormFieldContext.Provider, {
    value: formFieldApi,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    }
  }, children)));
};
var FormFieldContainer = withTheme(styled.label.withConfig({
  displayName: "FormField__FormFieldContainer",
  componentId: "sc-1g2b99v-0"
})(function (_ref2) {
  var coreTheme = _ref2.coreTheme,
    hasFocus = _ref2.hasFocus,
    error = _ref2.error;
  return css(["display:block;align-items:center;background-color:", ";border:1px solid transparent;position:relative;width:100%;transition:all 0.2s ease-in-out;border-radius:", "px;", " ", ""], function (p) {
    return p.disabled ? 'transparent' : p.bgColor;
  }, coreTheme.space_2, hasFocus && css(["border-color:", ";background-color:", ";"], coreTheme.cl_sec_d1, coreTheme.cl_white), error && css(["border-color:", ";"], coreTheme.cl_pri_d3));
}));
var InputContainer = withTheme(styled.div.withConfig({
  displayName: "FormField__InputContainer",
  componentId: "sc-1g2b99v-1"
})(["", ";"], function (p) {
  var _p$coreTheme$inputTex, _p$coreTheme, _p$coreTheme$inputTex2;
  return responsiveStyles({
    padding: (_p$coreTheme$inputTex = (_p$coreTheme = p.coreTheme) === null || _p$coreTheme === void 0 ? void 0 : (_p$coreTheme$inputTex2 = _p$coreTheme.inputText) === null || _p$coreTheme$inputTex2 === void 0 ? void 0 : _p$coreTheme$inputTex2.padding) !== null && _p$coreTheme$inputTex !== void 0 ? _p$coreTheme$inputTex : ["".concat(p.coreTheme.space_9, "px ").concat(p.coreTheme.space_4, "px ").concat(p.coreTheme.space_4, "px")]
  }, p.coreTheme);
}));
export default FormField;